module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"San Bernardino","start_url":"/","display":"minimal-ui","icon":"./static/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"b27e1b6130bb82a02b38b33bfb411126"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
